import { PluginsEventBus } from './pluginsEventBus';

/**
 * Notifies plugins that the current search selection was cleared - for instance after clicking
 * an empty area of the map. One event per category is dispatched so that plugins listening to a
 * single category can always reset their state.
 */
export const dispatchEmptySearchEvents = (): void => {
  PluginsEventBus.dispatchEvent('onSearch', {
    type: 'bioEntity',
    searchValues: [],
    results: [],
  });
  PluginsEventBus.dispatchEvent('onSearch', {
    type: 'drugs',
    searchValues: [],
    results: [],
  });
  PluginsEventBus.dispatchEvent('onSearch', {
    type: 'chemicals',
    searchValues: [],
    results: [],
  });
};
